import I18n from '../../../config/i18n';

const staticBookingData = () => ({
  limitations_headline: I18n.t('booking.limitations'),
  bookingProcess: {
    headline: I18n.t('booking.booking_process'),
    confirmation: I18n.t('booking.booking_process_confirmation'),
    paymentDetails: I18n.t('booking.booking_process_payment_details'),
  },
  bookingContact: {
    headline: I18n.t('booking.contact_host'),
    content: I18n.t('booking.host_contact'),
  },
  europeeneExplanation: {
    headline: I18n.t('booking.insurances'),
    content: I18n.t('booking.europeene_explanation'),
  },
});

export default staticBookingData;
